// ═══════════════════════════════════════════════════════════════
// API: Ingresos de Nómina (Aprobaciones)
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const aprobarIngreso = (id) =>
  api.post(`/payroll-incomes/${id}/aprobar`).then(r => r.data);

export const rechazarIngreso = (id, motivo) =>
  api.post(`/payroll-incomes/${id}/rechazar`, { motivo }).then(r => r.data);

export const revertirIngreso = (id, motivo) =>
  api.post(`/payroll-incomes/${id}/revertir`, { motivo }).then(r => r.data);
